<template>
    <div>
        <div class="mcc-page-header">
            <section class="mu-d-flex">
                <h1 class="mu-mb-00 mu-mr-02">REST adapter</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">

                        <p class="mu-mb-00">
                            {{ (isEditPage) ? helpTextEdit.title : helpTextCreate.title }}
                            <a :href="helpTextCreate.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
            <section>
                <div role="group" class="mcc-button-group mcc-button-group--spaced mu-d-flex mu-align-items-center"
                    v-if="isEditPage">
                    <button class="mcc-button mcc-button--outline" id="exportBtn" @click="exportAdapter()"
                        title="Export">
                        <mcc-icon name="export" aria-hidden="true"></mcc-icon><span
                            class="mcc-button__label">Export</span>
                    </button>
                </div>
            </section>
        </div>
        <div class="mcc-container--fluid card-padding">
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Integrate</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">External systems</a>
                    </li>
                    <li>
                        <router-link class="table-link"
                            :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId">{{ externalSystem.name
                            }}</router-link>
                    </li>
                    <li>
                        <a class="table-link" @click="redirectToRestAPI()">{{ externalSystemAPI.name }}</a>
                    </li>

                    <li aria-current="page">{{ (isEditPage) ? restAdapterName : 'Create new' }}</li>
                </ol>
            </nav>
            <div class="mcc-card">
                <div class="mcc-card__body">
                
            <div class="mcc-row" v-show="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                </circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div style="position:relative">
                <div v-if="!updateCall" class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                            </circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
               
                 
                        <div class="mcc-row" v-show="fetchCall">
                    <div class="mcc-col mcc-col-xs-12 mcc-col-md-12 mcc-col-sm-12">
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact"
                            id="externalSystemReadOnly" v-if="isReadOnly" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <p>
                                <strong>Warning!</strong>
                                <br />{{ readOnlyMsg }}
                                <br />
                            </p>
                        </mcc-alert>

                    </div>
               
                        <form id="restAdapterForm" ref="restAdapterForm" @submit.prevent="saveRestAdpater()" novalidate>
                        <div class="mcc-row">
                            <div class="mcc-col mcc-col-md-6">
                                    <div class="mcc-card">
                                        <div class="mcc-card__header">
                                            <h2 class="mcc-card__title">Configuration</h2>
                                        </div>
                                        <div class="mcc-card__body">
                                            <div class="mcc-row">
                                                <div class="mcc-col">
                                                    <div
                                                        class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap">
                                                        <label for="name"
                                                            class="mfc-label--required mu-mb-00">Name</label>
                                                        <div class="mfc-input-group">
                                                            <input type="text" id="name" name="name" required
                                                                placeholder="Adapter name" maxlength="50"
                                                                :disabled="isReadOnly" ref="name"
                                                                :value="restAdapterDTO.name" :pattern="nameRegex"
                                                                @change="updateName($event)">
                                                            <button type="button" class="mcc-button mcc-button--outline"
                                                                @click="redirectToHelpURL()"
                                                                v-if="externalSystemAPI.helpURL != null && externalSystemAPI.helpURL != ''"
                                                                title="Rest API help documentation">
                                                                <mcc-icon name="help"
                                                                    aria-hidden="true"></mcc-icon><span
                                                                    class="mcc-button__label"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap">
                                                        <label for="adapterPrefix"
                                                            class="mfc-label--required mu-mb-00">Prefix</label>
                                                        <input type="text" id="adapterPrefix" name="adapterPrefix"
                                                            required placeholder="Prefix" maxlength="50"
                                                            :disabled="isReadOnly" ref="adapterPrefix"
                                                            :value="restAdapterDTO.adapterPrefix" :pattern="nameRegex"
                                                            @change="updatePrefix($event)">
                                                    </div>

                                                    <div class=" mcc-segmented-buttons input-gap">
                                                        <fieldset class="mfc-fieldset" ref="httpMethod"
                                                            name="httpMethod" id="httpMethod" required
                                                            :value="restAdapterDTO.httpMethod"
                                                            @change="restAdapterDTO.httpMethod = $event.target.value">
                                                            <legend class="mfc-label mfc-label--required mu-mb-00">
                                                                Method</legend>
                                                            <div class="mcc-segmented-buttons__list">
                                                                <input id="getType" value="GET" name="httpMethodType"
                                                                    type="radio" :disabled="isReadOnly"
                                                                    :checked="restAdapterDTO.httpMethod === 'GET' || restAdapterDTO.httpMethod == ''">
                                                                <label for="getType">GET</label>
                                                                <input id="putType" value="PUT" name="httpMethodType"
                                                                    type="radio" :disabled="isReadOnly"
                                                                    :checked="restAdapterDTO.httpMethod === 'PUT'">
                                                                <label for="putType">PUT</label>
                                                                <input id="postType" value="POST" name="httpMethodType"
                                                                    type="radio" :disabled="isReadOnly"
                                                                    :checked="restAdapterDTO.httpMethod === 'POST'">
                                                                <label for="postType">POST</label>
                                                                <input id="patchType" value="PATCH"
                                                                    name="httpMethodType" type="radio"
                                                                    :disabled="isReadOnly"
                                                                    :checked="restAdapterDTO.httpMethod === 'PATCH'">
                                                                <label for="patchType">PATCH</label>
                                                                <input id="deleteType" value="DELETE"
                                                                    name="httpMethodType" type="radio"
                                                                    :disabled="isReadOnly"
                                                                    :checked="restAdapterDTO.httpMethod === 'DELETE'">
                                                                <label for="deleteType">DELETE</label>

                                                            </div>

                                                        </fieldset>
                                                    </div>

                                                    <div class="mcc-row ">
                                                        <div class="mcc-col">
                                                            <div class="mfc-input-wrapper  mfc-form-input-container input-gap">
                                                                <label for="urlSuffix"
                                                                    class=" mfc-label--required ">Path</label>
                                                                <div class="mfc-input-group mfc-input-group--has-help-text mfc-input-group--has-validation-text "
                                                                    id="urlSuffixDiv">
                                                                    <span class="splitInputReadOnly"
                                                                        ></span>
                                                                    <input type="text" id="urlSuffix" name="urlSuffix"
                                                                        required="" placeholder="URL"
                                                                        :disabled="isReadOnly"
                                                                        @change="handleUrlSuffixKeyUpEvent($event)"
                                                                        ref="urlSuffix"
                                                                        :prepend="restAdapterDTO.baseUrl + '/'"
                                                                        :pattern="suffixURL">

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div
                                                        class="mfc-textarea-wrapper mfc-form-input-container input-gap">
                                                        <label for="body">Body</label>
                                                        <textarea id="body" rows="6" name="body" maxlength="100000"
                                                            :disabled="isReadOnly" @input="handleBodyKeyUpEvent($event)"
                                                            ref="body" placeholder="Body" character-count=""></textarea><div class="mfc-invalid-feedback"></div>
                                                        <span class="mfc-help-text">
                                                            <span v-if="restAdapterDTO.body">
                                                                You have {{ 100000 - restAdapterDTO.body.length }}
                                                                characters remaining</span>
                                                                <span v-else>You have 100000
                                                                characters remaining</span>
                                                        </span>


                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                               
                            </div>
                            <div class="mcc-col mcc-col-md-6">
                                <div class="mcc-card fullHeightCard">
                                    <div class="mcc-card__header">
                                        <h2 class="mcc-card__title">Parameter types</h2>
                                    </div>
                                    <div class="mcc-card__body">
                                        <div>
                                            <div class="mcc-row"
                                                v-for="(item, index) in restAdapterDTO.restParameterTypes"
                                                :key="index + item.fieldName">
                                                <div class="mcc-col-8">
                                                    <div class="mfc-select-wrapper mu-mb-03">
                                                        <label :for="'restParamsTypeCmp' + index" class="mu-mb-00">{{
                                item.fieldName }}</label>
                                                        <select :id="'restParamsTypeCmp' + index" :disabled="isReadOnly"
                                                            @change="item.fieldType = $event.target.value"
                                                            :data-value="item.fieldType">
                                                            <option :selected="item.fieldType === 'STRING'"
                                                                value="STRING">String</option>
                                                            <option :selected="item.fieldType === 'BOOLEAN'"
                                                                value="BOOLEAN">Boolean</option>
                                                            <option :selected="item.fieldType === 'DOUBLE'"
                                                                value="DOUBLE">Double</option>
                                                            <option :selected="item.fieldType === 'FLOAT'"
                                                                value="FLOAT">Float</option>
                                                            <option :selected="item.fieldType === 'INT'" value="INT">Int
                                                            </option>
                                                            <option :selected="item.fieldType === 'LONG'" value="LONG">
                                                                Long</option>
                                                            <option :selected="item.fieldType === 'DATE'" value="DATE">
                                                                Date</option>
                                                            <option :selected="item.fieldType === 'TIME'" value="TIME">
                                                                Time</option>
                                                            <option :selected="item.fieldType === 'TIMESTAMP'"
                                                                value="TIMESTAMP">Timestamp</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="mcc-col adapter-mandatory">
                                                    <div class="mfc-checkbox-wrapper mfc-form-input-container mu-mt-04">
                                                        <input type="checkbox"
                                                            :id="'restParamsTypeCmpMandatory' + index"
                                                            class="mfc-switch" :disabled="isReadOnly"
                                                            :name="'restParamsTypeCmpMandatory' + index"
                                                            :checked="item.mandatory"
                                                            @change="item.mandatory = $event.target.checked">
                                                        <label
                                                            :for="'restParamsTypeCmpMandatory' + index">Mandatory</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="mu-d-flex mu-justify-content-end mu-mt-05">
                            <div role="group" class="mcc-button-group mcc-button-group--spaced mcc-button-group-flex-wrap">

                            <button class="mcc-button mcc-button--soft-danger" type="button"
                                v-if="isEditPage && !isReadOnly" id="deleteRestAdapterBtn"
                                @click="showDeleteAdapterDialog()" title="Delete">
                                <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span
                                    class="mcc-button__label ">Delete</span>
                            </button>
                            <router-link class="mu-mr-05" v-if="isEditPage && !isReadOnly"
                                :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId + '/apis/' + externalSystemAPI.id + '/restadapters/new?copyAdapterId=' + restAdapterDTO.id">
                                <button class="mcc-button mcc-button--outline" id="copyBtn" title="Copy" type="button">
                                    <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span
                                        class=" mcc-button__label">Copy</span>
                                </button>
                            </router-link>
                            <router-link class="mu-mr-05" v-if="!isEditPage"
                                :to="copyAdapter ? CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId + '/apis/' + externalSystemAPI.id + '/restadapters/' + copyAdapterId : CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId + '/apis/' + externalSystemAPI.id">
                                <button class="mcc-button mcc-button--outline" id="cancelBtn" title="Cancel" type="button">                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span
                                        class=" mcc-button__label">Cancel</span>
                                </button>
                            </router-link>
                            <button class="mcc-button mcc-button--outline" type="button" id="testRestBtn"
                                @click="showTestAdapterDialog()" title="Test adapter">
                                <mcc-icon name="connected" aria-hidden="true"></mcc-icon><span
                                    class=" mcc-button__label">Test adapter</span>
                            </button>

                            <button class="mcc-button mcc-button--success" v-if="!isReadOnly" id="saveBtn" title="Save"
                                type="submit" >
                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span
                                    class=" mcc-button__label">Save</span>
                            </button>
                        </div>
                    </div> </form>
                    </div>

                
            </div>
        </div>
    </div>
        </div>
        <div class="mcc-dialog-overlay">
            <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" v-if="dataLoaded" id="deleteRestAdapter"
                ref="deleteRestAdapter">
                <form  novalidate>
                    <section>
                        <div class="mcc-dialog__header">
                            <h4>Delete REST adapter</h4>
                            <button type="button"
                                class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only"
                                @click="$refs.deleteRestAdapter.close()">
                                <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Button</span>
                            </button>
                        </div>
                        <div class="mcc-dialog__body">
                            Are you sure you want to delete REST adapter?
                        </div>
                        <div class="mcc-dialog__footer">

                            <div class="mcc-button-group mcc-button-group--spaced">
                                <button type="button" class="mcc-button mcc-button--outline"
                                    @click="$refs.deleteRestAdapter.close()">No</button>
                                <button type="button" class="mcc-button mcc-button--danger"
                                    @click="deleteRestAdapter($event)">Yes</button>
                            </div>
                        </div>
                    </section>
                </form>
            </dialog>
        </div>
        <div class="mcc-dialog-overlay">
            <dialog :class="['mcc-dialog', 'mcc-dialog--primary', 'mcc-dialog--xs']" id="emptyTestAdapterDialog"
                ref="emptyTestAdapterDialog">
                <section>
                        <div class="mcc-dialog__header">
                            <h4>Test adapter</h4>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only"
                            @click="$refs.emptyTestAdapterDialog.close()">
                            <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">Button</span>
                        </button>
                        </div>
                        <div class="mcc-dialog__body">
                                <div class="mcc-placeholder mcc-placeholder--animation" v-show="fetchGridData">
  <div></div>
  <div></div>
</div>
                            <div v-show="testAdapterResult != ''" >
                                            <div style="word-break: break-all;" id="testAdapterResult"
                                                v-html="testAdapterResult">
                                            </div>
                                            <p id="restResultData" style='word-break: break-all;'></p>
                                        </div>                        
                                        <div v-show="testAdapterResultError != ''" >
                                            <div style="word-break: break-all;" id="testAdapterResult"
                                                v-html="testAdapterResultError">
                                            </div>
                                        </div></div>
                        <div class="mcc-dialog__footer">

                            <div class="mcc-button-group mcc-button-group--spaced">
                                <button type="button" class="mcc-button mcc-button--primary"
                                    @click="testAdapter(true)">Test again</button>
                                <button type="button" class="mcc-button mcc-button--outline"
                                    @click="$refs.emptyTestAdapterDialog.close()">Close</button>
                            </div>
                        </div>
                    </section>
                </dialog>
        </div>
        <div class="mcc-dialog-overlay">
            <dialog :class="['mcc-dialog', 'mcc-dialog--primary', 'mcc-dialog--xs']" id="testAdapterDialog"
                ref="testAdapterDialog">
                <section>
                    <div class="mcc-dialog__header">
                        <h4>Test adapter</h4>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only"
                            @click="closetestAdapterDialog()">
                            <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">Button</span>
                        </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <form ref="testAdapterDialogFormRef" novalidate>

                            <mcc-alert role="alert" class="mcc-alert mcc-alert--warning"
                                v-show="restAdapterDTO.httpMethod == 'PUT' || restAdapterDTO.httpMethod == 'POST' || restAdapterDTO.httpMethod == 'DELETE' || restAdapterDTO.httpMethod == 'PATCH'">
                                <mcc-icon name="error" aria-hidden="true" icon-set="fluency-filled"></mcc-icon>
                                <span class="mu-fw-semi-bold">
                                    Testing POST, PUT, DELETE or PATCH requests will change data in the end system.
                                    Ensure you understand the implications before clicking the Test button.
                                </span>
                            </mcc-alert>
                            <details class="mcc-accordion mcc-card mcc-card--high-emphasis" v-if="restAdapterDTO.restParameterTypes.length > 3" >
                                <summary>
                                    <span class="mcc-accordion__label">Input lines</span>
                                    <mcc-icon class="mcc-accordion__caret mu-ml-auto" name="expand_arrow" aria-hidden="true"></mcc-icon>
                                </summary>
                                <div class="mcc-accordion__body">

                                    <div class="mfc-input-wrapper mu-d-block paraminpopup mfc-form-input-container input-gap  mfc-form-input-wrapper--width"
                                        v-for="(item, index) in restAdapterDTO.restParameterTypes" :key="index">
                                        <label :for="'param_' + index">{{ item.fieldName }}</label>
                                        <input type="text" value="" :id="'param_' + index">
                                        <div class="mfc-help-text"></div>

                                    </div>
                              </div>
                            </details>
                                    <div  v-else class="mfc-input-wrapper mu-d-block paraminpopup mfc-form-input-container input-gap  mfc-form-input-wrapper--width"
                                        v-for="(item, index) in restAdapterDTO.restParameterTypes" :key="index">
                                        <label :for="'param_' + index">{{ item.fieldName }}</label>
                                        <input type="text" value="" :id="'param_' + index">
                                        <div class="mfc-help-text"></div>

                                 </div>
                             

                            <div class="mcc-row" v-show="fetchGridData">
                                <div class="mcc-col colSpinner">
                                    <div class="spinner-overlay">
                                        <div class="spinner-background"></div>
                                        <div class="spinner-flex">
                                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                                style="width: 48px; height: 48px; ">
                                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none"
                                                    stroke-width="5"></circle>
                                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="!fetchGridData" class="mu-mt-05">
                                <div class="mcc-card mcc-card--success-soft" id="testResultAlert" v-show="testAdapterResult != ''">
                                    <div class="mcc-card__header">
                                        <h2 class="mcc-card__title">Result</h2>
                                    </div>
                                    <div class="mcc-card__body">
                                        <div v-show="testAdapterResult != ''" >
                                            <div style="word-break: break-all;" id="testAdapterResult"
                                                v-html="testAdapterResult">
                                            </div>
                                            <p id="restResultData" style='word-break: break-all;'></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="mcc-card mcc-card--danger-soft" id="testResultAlertError" v-show="testAdapterResultError != ''">
                                    <div class="mcc-card__header">
                                        <h2 class="mcc-card__title">Result</h2>
                                    </div>
                                    <div class="mcc-card__body">
                                        <div v-show="testAdapterResultError != ''" >
                                            <div style="word-break: break-all;" id="testAdapterResult"
                                                v-html="testAdapterResultError">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </form>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline"
                                @click="closetestAdapterDialog()">Cancel</button>
                            <button type="button" class="mcc-button mcc-button--primary" id="testAdapterBtn"
                                @click="testAdapter(false)" title="Test adapter">
                                <span class="mcc-button__label">Test adapter</span>
                            </button>

                        </div>
                    </div>
                </section>
            </dialog>
        </div>
    </div>
</template>

<script>
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import ImportExportAPI from "../../../services/ImportExportAPI";
import RestAdapterAPI from "../../../services/RestAdapterAPI";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "RestAdapterEdit",
    data() {
        return {
            restAdapterDTO: {
                httpMethod: 'GET',
                baseUrl: '',
                restParameterTypes: [],
                inputParameters: [],
                body: '',
            },
            updateCall: true,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            suffixURL: constantMessages.PATTERNS["suffixURL"],
            helpTextCreate: constantMessages.BREADCRUMB_HELP["restadapter.create"],
            helpTextEdit: constantMessages.BREADCRUMB_HELP["restadapter.edit"],
            dataLoaded: false,
            copyAdapter: false,
            copyAdapterId: this.$route.query.copyAdapterId,
            showHelpText: false,
            fetchCall: true,
            isEditPage: false,
            externalSystemId: this.$route.params.externalSystemId,
            externalSystem: {},
            externalSystemAPI: {
                helpURL: 'helpURL'
            },
            restAdapterName: '',
            restadapterId: this.$route.params.restadapterId,
            params: [],
            fetchGridData: false,
            baseUrl: '',
            testAdapterResult: '',
            testAdapterResultError: '',
            baseUrlKey: 0,
            isReadOnly: false,
            readOnlyMsg: constantMessages.MESSAGES["error.externalsystems.readonly"],
            dialogColor: ''
        }
    },
    
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        let pageTitle;
        self.isEditPage = self.restadapterId != null && self.restadapterId != 'new';

        RestAdapterAPI.getAPIInfo(self.$route.params.externalSystemId, self.$route.params.apiId).then(response => {
            if (response != null) {
                self.externalSystem = response.externalSystemAPI.externalSystem;
                self.isReadOnly = self.externalSystem.readOnly;
                self.externalSystemAPI = response.externalSystemAPI;
                self.restAdapterDTO.baseUrl = response.baseUrl;
                self.baseUrlKey += 1;
                if (!self.isEditPage) {
                    pageTitle = constantMessages.PAGEHEADER_TITLE["menu.restadapter.details"] + " - Create new";
                    EventBus.$emit("update-pageTitle", pageTitle);
                }
            }
        }).finally(function () {
            let content = self.restAdapterDTO.baseUrl;
            self.restAdapterDTO.baseUrl = content;
            document.querySelector('#urlSuffixDiv span').textContent = content;
        });

        let editObj;
        if (self.isEditPage || self.copyAdapterId != null) {
            self.fetchCall = false;
            let adapterId = self.restadapterId;
            if (self.copyAdapterId != null) {
                self.isEditPage = false;
                self.copyAdapter = true;
                adapterId = self.copyAdapterId;
            }
            RestAdapterAPI.getAdapterInfo(self.externalSystemId, self.$route.params.apiId, adapterId).then(response => {
                if (response != null) {
                    editObj = response;
                    self.restAdapterName = response.name;
                    self.dataLoaded = true;
                }
                pageTitle = constantMessages.PAGEHEADER_TITLE["menu.restadapter.details"] + " - " + self.restAdapterName;
                EventBus.$emit("update-pageTitle", pageTitle);
            }).finally(function () {
                self.fetchCall = true;
                setTimeout(() => {
                    self.setAdapterData(editObj);
                    self.baseUrlKey += 1;
                }, 500);
            });
        }
    },
    methods: {
        closetestAdapterDialog() {
            this.$refs.testAdapterDialogFormRef.reset();
            this.$refs.testAdapterDialog.close()
        },
        setAdapterData(editObj) {
            let self = this;
            self.restAdapterDTO = editObj;
            self.$refs.name.value = editObj.name;
            self.$refs.adapterPrefix.value = editObj.adapterPrefix;
            self.$refs.httpMethod.checked = editObj.httpMethod;
            $("#urlSuffix")[0].setAttribute("value", editObj.urlSuffix);
            $("#body").val(editObj.body != null ? editObj.body : "")
            self.baseUrl = editObj.baseUrl;
            if (self.copyAdapterId != null) {
                self.restAdapterDTO.id = null;
                self.restAdapterDTO.name = self.restAdapterDTO.name + " - copy";
                if (self.restAdapterDTO.name.length > 50) {
                    self.restAdapterDTO.name = self.restAdapterDTO.name.substring(0, 50);
                }
                if (self.copyAdapter) {
                    self.updateParamsCopy();
                }
            }
        },
        exportAdapter() {
            ImportExportAPI.exportFiles('RESTADAPTER', this.restadapterId);
        },
        redirectToRestAPI() {
            let self = this;
            localStorage.setItem("APIList", "APIList");
            self.$router.push(self.CONTEXT_PATH + '/integrate/externalsystems/' + self.externalSystemId + '/apis/' + self.externalSystemAPI.id);
        },
        saveRestAdpater() {
            let form = $("#restAdapterForm");
            if (!form[0].checkValidity()) {
                if (this.$refs.name.value == "") {
                    let feedback = $(this.$refs.name).closest('.mfc-input-group').find('.mfc-invalid-feedback');
                    if (feedback.length === 0) {
                        feedback = $('<div class="mfc-invalid-feedback"></div>').appendTo($(this.$refs.name).closest('.mfc-input-group'));
                    }
                    feedback.empty();
                } else {
                    this.$refs.name.classList.remove("ms-is-invalid")
                }
                if ($(this.$refs.httpMethod).attr("value") == "" || $(this.$refs.httpMethod).attr("value") == undefined) {
                    let feedback = $(this.$refs.httpMethod).next('.mfc-invalid-feedback');
                    if (feedback.length === 0) {
                        feedback = $('<div class="mfc-invalid-feedback">Method is required</div>').insertAfter($(this.$refs.httpMethod));
                    } else {
                        $(feedback).text = "Method is required";
                    }
                } else {
                    $(this.$refs.httpMethod).next('.mfc-invalid-feedback').empty();
                }
                handleFormValidation(form, validationMessages);
                return;
            }
            let self = this;
            self.updateCall = false;
            RestAdapterAPI.saveRestAdapter(self.restAdapterDTO, self.$route.params.externalSystemId, self.$route.params.apiId).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            let feedback = $(this.$refs.name).closest('.mfc-input-group').find('.mfc-invalid-feedback');
                            if (feedback.length === 0) {
                                feedback = $('<div class="mfc-invalid-feedback"></div>').appendTo($(this.$refs.name).closest('.mfc-input-group'));
                            }
                            feedback.empty();
                            self.$refs.name.classList.add("ms-is-invalid");
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]]);
                        } else if (k == "prefix") {
                            displayErrorMessage($(self.$refs.adapterPrefix), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.adapterPrefix.classList.add("ms-is-invalid");
                        } else if (k == "urlSuffix") {
                            displayErrorMessage($(self.$refs.urlSuffix), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.urlSuffix.classList.add("ms-is-invalid");
                        } else if (k == "httpMethod") {
                            let feedback = $(this.$refs.httpMethod).next('.mfc-invalid-feedback');
                            if (feedback.length === 0) {
                                feedback = $('<div class="mfc-invalid-feedback">' + constantMessages.MESSAGES[response.messages[k]] + '</div>').insertAfter($(this.$refs.httpMethod));
                            } else {
                                $(feedback).text = constantMessages.MESSAGES[response.messages[k]];
                            }
                        }
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    if (!self.isEditPage) {
                        self.$router
                            .push(
                                self.CONTEXT_PATH +
                                "/integrate/externalsystems/" +
                                self.externalSystem.id +
                                "/apis/" + self.$route.params.apiId +
                                "/restadapters/" + response.data.id
                            )
                    } else {
                        self.restAdapterName = response.data.name;
                        self.restAdapterDTO = response.data;
                    }
                }
            });
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                let feedback = $(this.$refs.name).closest('.mfc-input-group').find('.mfc-invalid-feedback');
                if (feedback.length === 0) {
                    feedback = $('<div class="mfc-invalid-feedback"></div>').appendTo($(this.$refs.name).closest('.mfc-input-group'));
                }
                feedback.empty();
                self.$refs.name.classList.add("ms-is-invalid");
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
            } else if (event.target.value.length > 50) {
                let feedback = $(this.$refs.name).closest('.mfc-input-group').find('.mfc-invalid-feedback');
                if (feedback.length === 0) {
                    feedback = $('<div class="mfc-invalid-feedback"></div>').appendTo($(this.$refs.name).closest('.mfc-input-group'));
                }
                feedback.empty();
                self.$refs.name.classList.add("ms-is-invalid");
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
            } else if (!event.target.value.match(this.nameRegex)) {
                let feedback = $(this.$refs.name).closest('.mfc-input-group').find('.mfc-invalid-feedback');
                if (feedback.length === 0) {
                    feedback = $('<div class="mfc-invalid-feedback"></div>').appendTo($(this.$refs.name).closest('.mfc-input-group'));
                }
                feedback.empty();
                self.$refs.name.classList.add("ms-is-invalid");
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.restAdapterDTO.name = event.target.value;
        },
        updatePrefix(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.adapterPrefix), constantMessages.MESSAGES["error.prefix.required"])
                self.$refs.adapterPrefix.classList.add("ms-is-invalid");
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.adapterPrefix), constantMessages.MESSAGES["error.prefix.length"])
                self.$refs.adapterPrefix.classList.add("ms-is-invalid");
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.adapterPrefix), constantMessages.MESSAGES["error.prefix.invalid"])
                self.$refs.adapterPrefix.classList.add("ms-is-invalid")
            } else {
                self.$refs.adapterPrefix.classList.remove("ms-is-invalid");
            }
            self.restAdapterDTO.adapterPrefix = event.target.value;
        },
        showDeleteAdapterDialog() {
            $("#deleteRestAdapter")[0].show();
        },
        showTestAdapterDialog() {

            if(this.restAdapterDTO.restParameterTypes.length != 0)
            {
            this.dialogColor= 'primary'
            self.params = [];
            this.fetchGridData = false;
            $(".paraminpopup").val(" ");
            $(".paraminpopup").val("");
            self.testAdapterResult = "";
            self.testAdapterResultError = "";
            $("#testResultAlert").hide();
            $("#testResultAlertError").hide();
            $("#resultDiv").hide();
            $('.mcc-accordion.mcc-card').attr("open", true);
            $("#testAdapterDialog")[0].show();
            }
            else
            {
                this.testAdapter(true)
              

            }
        },
        updateParamsCopy() {
            let self = this;
            let updatedRestParameterTypes = [];
            let existingParamTypes = self.restAdapterDTO.restParameterTypes;
            if (existingParamTypes != null) {
                $.each(existingParamTypes, function (key, value) {
                    updatedRestParameterTypes.push({
                        "fieldName": value.fieldName,
                        "fieldType": value.fieldType,
                        "mandatory": value.mandatory,
                        "id": null,
                        "version": 0,
                        "deleted": null,
                        "sqlApiAdapter": null
                    });
                });
            }
            self.restAdapterDTO.restParameterTypes = updatedRestParameterTypes;
        },
        handleBodyKeyUpEvent(e) {
            this.restAdapterDTO.body = e.target.value;
            this.updateParams($("#body").val().concat(
                $("#urlSuffix").val()));
        },
        handleUrlSuffixKeyUpEvent(e) {
            this.restAdapterDTO.urlSuffix = e.target.value;
            this.updateParams($("#body").val().concat(
                $("#urlSuffix").val()));
        },
        updateParams(data) {
            setTimeout(() => {
                let self = this;
                let updatedRestParameterTypes = [];
                let existingParamTypes = self.restAdapterDTO.restParameterTypes;
                self.restAdapterDTO.restParameterTypes = [];
                let parametersData = data;
                let re = /{{([^}]+)}}/g;
                let text;
                while (text = re.exec(parametersData)) {
                    let type = "STRING";
                    let mandatory = false;

                    $.each(existingParamTypes, function (key, value) {
                        if (value.fieldName == text[1]) {
                            type = value.fieldType;
                            mandatory = value.mandatory;

                        }
                    });
                    updatedRestParameterTypes.push({
                        "fieldName": text[1],
                        "mandatory": mandatory,
                        "fieldType": type,
                        "id": null,
                        "version": 0,
                        "deleted": null,
                        "restApiAdapter": null
                    });
                }
                self.restAdapterDTO.restParameterTypes = updatedRestParameterTypes;
            }, 0);
        },
        deleteRestAdapter(e) {
            let self = this;
            self.updateCall = false;
            RestAdapterAPI.deleteRestAdapter(
                self.$route.params.externalSystemId, self.$route.params.apiId,
                self.restAdapterDTO.id
            ).then(response => {
                self.updateCall = true;
                if (response != null && !response.error) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    self.$router.push(self.CONTEXT_PATH + '/integrate/externalsystems/' + self.externalSystemId + '/apis/' + self.$route.params.apiId);
                }
                self.$refs.deleteRestAdapter.close();

            });
        },
        testAdapter(isFieldsEmpty) {
            let self = this;
            self.fetchGridData = true;
            self.testAdapterResult = "";
            self.testAdapterResultError = "";
            if(!isFieldsEmpty)
            {
            self.params = [];
            $(".paraminpopup").each(function (key, ele) {
                let label = $(ele).find('label').text();
                let value = $(ele).find('input').val();
                let obj = {
                    key: label,
                    value: value
                };
                self.params.push(obj);
            });
            $('.mcc-accordion.mcc-card').attr("open", false);
            let paramsObj = JSON.parse(JSON.stringify(self.params));
            self.restAdapterDTO.inputParameters = paramsObj;
            }
            let messageData = "";
            RestAdapterAPI.testConnection(self.restAdapterDTO, self.$route.params.externalSystemId, self.$route.params.apiId).then(responseData => {
                if (responseData != null) {
                    if (responseData.error === true) {
                        self.dialogColor= 'danger'
                        self.testAdapterResultError = responseData.data;
                    } else {
                        self.dialogColor= 'success'
                        self.testAdapterResult = responseData.data;
                        if (responseData.message) {
                            messageData = responseData.message;
                        }
                    }
                }
            }).finally(function () {
                self.fetchGridData = false;
                if (messageData != "") {
                    $("#testResultAlert #restResultData").text(messageData);
                    $('#testResultAlert #restResultData').jsonFormatter();
                    $("#emptyTestAdapterDialog #restResultData").text(messageData);
                    $('#emptyTestAdapterDialog #restResultData').jsonFormatter();                
                }
                if(isFieldsEmpty)
                {
                    self.$refs.emptyTestAdapterDialog.show()
                }
            });
        },
        redirectToList() {
            localStorage.setItem("externalSystemList", "externalSystemList");

            this.$router.push(
                this.CONTEXT_PATH + '/integrate/externalsystems'
            );
        },
        redirectToHelpURL() {
            window.open(this.externalSystemAPI.helpURL, "_blank");
        }
    },
}
</script>

<style scoped>
#restResultData {
    margin: 0 0 30px 0;
    padding: 30px;
    background: #EDEDED;
}

#testResultAlert,
#testResultAlertError {
    margin-bottom: 0px !important;
    overflow-y: hidden;
}

.adapter-mandatory {
    align-items: unset !important;
}
</style>
